// // import React, { useState } from 'react'
// // import axios from 'axios'
// // import { toAbsoluteUrl } from '../../AssetHelpers'

// // function UploadImage({ label, name, formik, required = true, isInArray = false }: any) {
// //   const [errorMessage, setErrorMessage] = useState('')

// //   console.log("hello world")

// //   // Handle file change event for image upload
// //   const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
// //     const file = event.target.files ? event.target.files[0] : null
// //     if (!file) return

// //     // Check file size (1 MB = 1,048,576 bytes)
// //     // if (file.size > 1048576) {
// //     //   setErrorMessage('Max file size is 1 MB.')
// //     //   return
// //     // }
// //     if (file.size > 5242880) {
// //       setErrorMessage('Max file size is 5 MB.')
// //       return
// //     }

// //     setErrorMessage('') // Clear any previous error messages

// //     const formData = new FormData()
// //     formData.append('file', file)
// //     try {
// //       const response = await axios.post(
// //         process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '',
// //         formData,
// //         {
// //           headers: {
// //             'Content-Type': 'multipart/form-data',
// //             token:
// //               'Bearer eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJjcmVhdGVkVGltZSI6MTY5MzMyMTg2MDU1MCwiZXhwaXJ5VGltZSI6MTY5MzMyMTg5MDU1MCwidXNlclR5cGUiOiJTTUFSVF9DRU5UUkUiLCJ1c2VySWQiOiI2NGM5NDRhMWUwZDQzMTU1MDE1ZmJjYzIifQ.MOqTincx0tq--3BvYrH2WsM4PvydIMiKY2ZDj5ImaGQ',
// //           },
// //         }
// //       )
// //       const uploadedUrl = response?.data?.data?.name
// //       if (uploadedUrl) {
// //         if (isInArray) {
// //           const test = formik?.getFieldProps(name)?.value
// //           const updatedImages = [...test, uploadedUrl]
// //           formik.setFieldValue(name, updatedImages)
// //         } else {
// //           formik.setFieldValue(name, response.data.data.name)
// //         }

// //         // formik.setFieldValue(name, response.data.data.name)
// //       }
// //     } catch (error) {
// //       console.error('Error uploading file:', error)
// //       setErrorMessage('Failed to upload the image. Please try again.')
// //     }
// //   }

// //   // Default blank image URL for the initial state
// //   const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
// //   const imageUrls = formik.values[name] || []

// //   return (
// //     <div className='fv-row mb-7'>
// //       <label className={`d-block ${required ? 'required' : ''} fw-bold fs-6 mb-5`}>{label}</label>
// //       <div className='d-flex flex-wrap gap-3'>
// //         {/* Image upload component */}
// //         <div
// //           className='image-input image-input-outline'
// //           data-kt-image-input='true'
// //           style={{ backgroundImage: `url('${blankImg}')` }}
// //         >
// //           <div
// //             className='image-input-wrapper w-100px h-100px'
// //             style={{
// //               // backgroundImage: `url('${formik?.getFieldProps(name)?.value}')`,
// //               backgroundImage: isInArray
// //                 ? blankImg
// //                 : `url('${formik?.getFieldProps(name)?.value}')`,
// //             }}
// //           ></div>
// //           <label
// //             className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
// //             data-kt-image-input-action='change'
// //             data-bs-toggle='tooltip'
// //             title='Upload image'
// //           >
// //             <i className='bi bi-plus fs-7'></i>
// //             <input
// //               type='file'
// //               name='avatar'
// //               accept='.png, .jpg, .jpeg'
// //               onChange={handleFileChange}
// //             />
// //             <input type='hidden' name='avatar_remove' />
// //           </label>
// //           <span
// //             className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
// //             data-kt-image-input-action='cancel'
// //             data-bs-toggle='tooltip'
// //             title='Cancel avatar'
// //           >
// //             <i className='bi bi-x fs-2'></i>
// //           </span>
// //         </div>
// //       </div>

// //       {/* <div className='form-text'>Allowed file types: png, jpg, jpeg. Max file size 1 MB</div> */}
// //       <div className='form-text'>Allowed file types: <br /> png, jpg, jpeg. Max file size  &nbsp;<br /> 5 MB</div>
// //       {errorMessage && <div className='text-danger mt-2'>{errorMessage}</div>}
// //       {formik.errors[name] && (
// //         <div className='fv-plugins-message-container'>
// //           <div className='fv-help-block'>
// //             <span role='alert'>{formik.errors[name]}</span>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   )
// // }

// // export default UploadImage








// import React, { useState } from 'react'
// import axios from 'axios'
// import { toAbsoluteUrl } from '../../AssetHelpers'

// function UploadImage({ label, name, formik, required = true, isInArray = false }: any) {
//   const [errorMessage, setErrorMessage] = useState('')
//   const [uploadProgress, setUploadProgress] = useState(0)
//   const [isUploading, setIsUploading] = useState(false)

//   console.log("hello world")

//   // Handle file change event for image upload
//   const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files ? event.target.files[0] : null
//     if (!file) return

//     // Check file size (1 MB = 1,048,576 bytes)
//     // if (file.size > 1048576) {
//     //   setErrorMessage('Max file size is 1 MB.')
//     //   return
//     // }
//     if (file.size > 5242880) {
//       setErrorMessage('Max file size is 5 MB.')
//       return
//     }

//     setErrorMessage('') // Clear any previous error messages
//     setIsUploading(true)
//     setUploadProgress(0)

//     const formData = new FormData()
//     formData.append('file', file)
//     try {
//       const response = await axios.post(
//         process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '',
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//             token:
//               'Bearer eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJjcmVhdGVkVGltZSI6MTY5MzMyMTg2MDU1MCwiZXhwaXJ5VGltZSI6MTY5MzMyMTg5MDU1MCwidXNlclR5cGUiOiJTTUFSVF9DRU5UUkUiLCJ1c2VySWQiOiI2NGM5NDRhMWUwZDQzMTU1MDE1ZmJjYzIifQ.MOqTincx0tq--3BvYrH2WsM4PvydIMiKY2ZDj5ImaGQ',
//           },
//           onUploadProgress: (progressEvent) => {
//             const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1))
//             setUploadProgress(percentCompleted)
//           }
//         }
//       )
//       const uploadedUrl = response?.data?.data?.name
//       if (uploadedUrl) {
//         // if (isInArray) {
//         //   const test = formik?.getFieldProps(name)?.value
//         //   const updatedImages = [...test, uploadedUrl]
//         //   formik.setFieldValue(name, updatedImages)
//         // } else {
//         //   formik.setFieldValue(name, response.data.data.name)
//         // }

//         if (isInArray) {
//           const test = formik?.getFieldProps(name)?.value
//           const updatedImages = [...test, uploadedUrl]
//           formik.setFieldValue(name, updatedImages)
//         } else {
//           formik.setFieldValue(name, response.data.data.name)
//           formik.setFieldValue(`${name}_type`, file.type) // Add this line
//         }

//         // formik.setFieldValue(name, response.data.data.name)
//       }
//     } catch (error) {
//       console.error('Error uploading file:', error)
//       setErrorMessage('Failed to upload the image. Please try again.')
//     } finally {
//       setIsUploading(false)
//       setUploadProgress(0)
//     }
//   }

//   // Default blank image URL for the initial state
//   const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
//   const imageUrls = formik.values[name] || []

//   return (
//     <div className='fv-row mb-7'>
//       <label className={`d-block ${required ? 'required' : ''} fw-bold fs-6 mb-5`}>{label}</label>
//       <div className='d-flex flex-wrap gap-3'>
//         {/* Image upload component */}
//         <div
//           className='image-input image-input-outline'
//           data-kt-image-input='true'
//           style={{ backgroundImage: `url('${blankImg}')` }}
//         >
//           {/* <div
//             className='image-input-wrapper w-100px h-100px'
//             style={{
//               // backgroundImage: `url('${formik?.getFieldProps(name)?.value}')`,
//               backgroundImage: isInArray
//                 ? blankImg
//                 : `url('${formik?.getFieldProps(name)?.value}')`,
//             }}
//           ></div> */}


//           <div
//             className='image-input-wrapper w-100px h-100px'
//             style={{
//               backgroundImage: isInArray
//                 ? blankImg
//                 : formik.values[`${name}_type`] === 'application/pdf'
//                   ? 'none'
//                   : `url('${formik?.getFieldProps(name)?.value}')`,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               backgroundColor: formik.values[`${name}_type`] === 'application/pdf' ? '#f8f9fa' : 'transparent'
//             }}
//           >
//             {formik.values[`${name}_type`] === 'application/pdf' && (
//               <div style={{
//                 width: '40px',
//                 height: '50px',
//                 backgroundColor: '#dc3545',
//                 borderRadius: '4px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 color: 'white',
//                 fontSize: '10px',
//                 fontWeight: 'bold'
//               }}>
//                 PDF
//               </div>
//             )}
//           </div>
//           <label
//             className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
//             data-kt-image-input-action='change'
//             data-bs-toggle='tooltip'
//             title='Upload image'
//           >
//             <i className='bi bi-plus fs-7'></i>
//             <input
//               type='file'
//               name='avatar'
//               accept='.png, .jpg, .jpeg, .pdf'
//               onChange={handleFileChange}
//               disabled={isUploading}
//             />
//             <input type='hidden' name='avatar_remove' />
//           </label>
//           <span
//             className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
//             data-kt-image-input-action='cancel'
//             data-bs-toggle='tooltip'
//             title='Cancel avatar'
//           >
//             <i className='bi bi-x fs-2'></i>
//           </span>
//         </div>
//       </div>

//       {/* Progress bar */}
//       {isUploading && (
//         <div className='mt-3' style={{ width: '100px' }}>
//           <div className='progress' style={{ height: '6px' }}>
//             <div
//               className='progress-bar progress-bar-striped progress-bar-animated'
//               role='progressbar'
//               style={{ width: `${uploadProgress}%` }}
//               aria-valuenow={uploadProgress}
//               aria-valuemin={0}
//               aria-valuemax={100}
//             ></div>
//           </div>
//           <div className='text-dark mt-1 fs-7'>Uploading... {uploadProgress}%</div>
//         </div>
//       )}

//       {/* <div className='form-text'>Allowed file types: png, jpg, jpeg. Max file size 1 MB</div> */}
//       <div className='form-text'>Allowed file types: <br /> png, jpg, jpeg, pdf. Max file size  &nbsp;<br /> 5 MB</div>
//       {errorMessage && <div className='text-danger mt-2'>{errorMessage}</div>}
//       {formik.errors[name] && (
//         <div className='fv-plugins-message-container'>
//           <div className='fv-help-block'>
//             <span role='alert'>{formik.errors[name]}</span>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default UploadImage




import React, { useState } from 'react'
import axios from 'axios'
import { toAbsoluteUrl } from '../../AssetHelpers'

function UploadImage({ label, name, formik, required = true, isInArray = false }: any) {
  const [errorMessage, setErrorMessage] = useState('')
  const [uploadProgress, setUploadProgress] = useState(0)
  const [isUploading, setIsUploading] = useState(false)
  const [isImageBroken, setIsImageBroken] = useState(false)

  console.log("hello world")

  const handleImageError = () => {
    setIsImageBroken(true)
  }

  // Handle file change event for image upload
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null
    if (!file) return

    if (file.size > 5242880) {
      setErrorMessage('Max file size is 5 MB.')
      return
    }

    setErrorMessage('')
    setIsUploading(true)
    setUploadProgress(0)
    setIsImageBroken(false)

    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            token:
              'Bearer eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJjcmVhdGVkVGltZSI6MTY5MzMyMTg2MDU1MCwiZXhwaXJ5VGltZSI6MTY5MzMyMTg5MDU1MCwidXNlclR5cGUiOiJTTUFSVF9DRU5UUkUiLCJ1c2VySWQiOiI2NGM5NDRhMWUwZDQzMTU1MDE1ZmJjYzIifQ.MOqTincx0tq--3BvYrH2WsM4PvydIMiKY2ZDj5ImaGQ',
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1))
            setUploadProgress(percentCompleted)
          }
        }
      )
      const uploadedUrl = response?.data?.data?.name
      if (uploadedUrl) {
        if (isInArray) {
          const test = formik?.getFieldProps(name)?.value
          const updatedImages = [...test, uploadedUrl]
          formik.setFieldValue(name, updatedImages)
        } else {
          formik.setFieldValue(name, response.data.data.name)
          formik.setFieldValue(`${name}_type`, file.type)
        }
      }
    } catch (error) {
      console.error('Error uploading file:', error)
      setErrorMessage('Failed to upload the image. Please try again.')
    } finally {
      setIsUploading(false)
      setUploadProgress(0)
    }
  }

  // Default blank image URL for the initial state
  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const imageUrls = formik.values[name] || []

  return (
    <div className='fv-row mb-7'>
      <label className={`d-block ${required ? 'required' : ''} fw-bold fs-6 mb-5`}>{label}</label>
      <div className='d-flex flex-wrap gap-3'>
        {/* Image upload component */}
        <div
          className='image-input image-input-outline'
          data-kt-image-input='true'
          style={{ backgroundImage: `url('${blankImg}')` }}
        >
          <div
            className='image-input-wrapper w-100px h-100px'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: (isImageBroken || formik.values[`${name}_type`] === 'application/pdf') ? '#f8f9fa' : 'transparent',
              position: 'relative'
            }}
          >
            {!isImageBroken && formik.values[name] && formik.values[`${name}_type`] !== 'application/pdf' && !isInArray && (
              <img
                src={formik.values[name]}
                alt='preview'
                onError={handleImageError}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '4px'
                }}
              />
            )}

            {(isImageBroken || formik.values[`${name}_type`] === 'application/pdf') && (
              <div style={{
                width: '40px',
                height: '50px',
                backgroundColor: '#dc3545',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '10px',
                fontWeight: 'bold'
              }}>
                PDF
              </div>
            )}
          </div>

          <label
            className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
            data-kt-image-input-action='change'
            data-bs-toggle='tooltip'
            title='Upload image'
          >
            <i className='bi bi-plus fs-7'></i>
            <input
              type='file'
              name='avatar'
              accept='.png, .jpg, .jpeg, .pdf'
              onChange={handleFileChange}
              disabled={isUploading}
            />
            <input type='hidden' name='avatar_remove' />
          </label>
          <span
            className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
            data-kt-image-input-action='cancel'
            data-bs-toggle='tooltip'
            title='Cancel avatar'
          >
            <i className='bi bi-x fs-2'></i>
          </span>
        </div>
      </div>

      {/* Progress bar */}
      {isUploading && (
        <div className='mt-3' style={{ width: '100px' }}>
          <div className='progress' style={{ height: '6px' }}>
            <div
              className='progress-bar progress-bar-striped progress-bar-animated'
              role='progressbar'
              style={{ width: `${uploadProgress}%` }}
              aria-valuenow={uploadProgress}
              aria-valuemin={0}
              aria-valuemax={100}
            ></div>
          </div>
          <div className='text-dark mt-1 fs-7'>Uploading... {uploadProgress}%</div>
        </div>
      )}

      <div className='form-text'>Allowed file types: <br /> png, jpg, jpeg, pdf. Max file size  &nbsp;<br /> 5 MB</div>
      {errorMessage && <div className='text-danger mt-2'>{errorMessage}</div>}
      {formik.errors[name] && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors[name]}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default UploadImage